import { useActiveMembership } from '@batiflow/client-core/react';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { visibleAdminPages } from '@/features/admin';
import { NotFound } from '@/shared/components/route-states';

function AdminHome() {
  const { orgId } = Route.useParams();
  const membership = useActiveMembership();
  const first = visibleAdminPages(membership?.permissions)[0];
  if (!first) return <NotFound />;
  return <Navigate to={first.to} params={{ orgId }} replace />;
}

/** `/o/$orgId/admin`: opens the first administration page the member may see. */
export const Route = createFileRoute('/_auth/o/$orgId/admin/')({
  component: AdminHome,
});
